<h3>Members</h3>
<div class="row">
    <div class="col-sm-12 excel-link">
        <a href="{{ linkToExcel }}">Open all in Excel</a>
    </div>
</div>
<div>
    <eil-member-list></eil-member-list>
</div>
